import { __assign } from "tslib";
import * as React from "react";
var SvgTomIconTwitterX = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none" }, props),
    React.createElement("g", { clipPath: "url(#a)" },
        React.createElement("path", { fill: "currentColor", d: "m22.612 22.267-8.209-11.968.014.012 7.401-8.578h-2.473l-6.03 6.982-4.787-6.982H2.04l7.664 11.173h-.001l-8.083 9.36h2.473l6.704-7.767 5.327 7.768zM7.548 3.6l11.517 16.8h-1.96L5.578 3.6z" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "a" },
            React.createElement("path", { fill: "currentColor", d: "M0 0h24v24H0z" }))))); };
export default SvgTomIconTwitterX;
//# sourceMappingURL=TomIconTwitterX.js.map